import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-project-templates-create-project-from-template',
    templateUrl: './project-templates-create-project-from-template.component.html',
    styleUrls: ['./project-templates-create-project-from-template.component.scss'],
    standalone: false
})
export class ProjectTemplatesCreateProjectFromTemplateComponent implements OnInit {
	@Output() public popupVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	private _popupVisible: boolean = false;
	@Input()
	public set popupVisible(value: boolean) {
		this._popupVisible = value;

		this.popupVisibleChange.emit(this._popupVisible);
	}
	public get popupVisible(): boolean {
		return this._popupVisible;
	}
	
	public show() {
			this.popupVisible = true;
	}

	public hide() {
		this.popupVisible = false;
	}

	@Input() public title: string;
	
	@Input() public primaryButtonText: string = "Proceed";
	@Output() public onPrimaryButtonClicked: EventEmitter<any> = new EventEmitter<any>();

	@Input() public primaryLabel: string;
	@Input() public primaryValue: string;

	@Input() public secondaryLabel: string;
	@Input() public secondaryValue: Date | number | string;

	@Input() public tetriaryLabel: string;
	@Input() public tetriaryValue: string;
	@Input() public tetriaryItems: string[];

	@Input() public quaternaryLabel: string;

	@Output() public quaternaryValueChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	
	private _quaternaryValue: boolean;
	@Input()
	public set quaternaryValue(value: boolean) {
		this._quaternaryValue = value;

		this.quaternaryValueChange.emit(this._quaternaryValue);
	}
	public get quaternaryValue(): boolean {
		return this._quaternaryValue;
	}

	// public isInformationEnough: boolean = true;

	// @Output() public onSuccess: EventEmitter<any> = new EventEmitter<any>();

	// @Input() public popUpAction: "create" | "clone" | "clone-list";

	// @Input() public argument1: any;

	constructor(
		// private notificationService: NotificationService,
		// private forecastService: ForecastService,
	) {}

	ngOnInit() {
	}
	
	public onPrimaryButtonClick() {
		this.onPrimaryButtonClicked.emit({ primaryValue: this.primaryValue, secondaryValue: this.secondaryValue, tetriaryValue: this.tetriaryValue });
	}
}
